<h1>
    <p style="text-align: center"><b>Nota</b></p>
</h1>
<hr style="
    border-top: 1 px;
    border-width: 2px;
    width: 100%;
    border-color: #38572d;
  " />
<mat-dialog-content class="mat-typography">
    <mat-card class="example-card">
        <mat-card-header>
            <mat-card-title>
                <h2>
                    <p style="text-align: center">
                        <strong>La información del presente micrositio fue actualizada únicamente
              dentro del calendario del proceso electoral, por lo que el DIA de
              MES de AÑO es la última fecha de actualización.</strong
            >
          </p>
        </h2>
      </mat-card-title>
      <mat-card-subtitle> </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content style="padding: 5%">
      <h2>
        <p style="text-align: center">
          <strong
            >La demás información parlamentaria se encuentra debidamente
            actualizada en los apartados correspondientes y atendiendo la
            normatividad de esta Cámara.</strong
          >
        </p>
      </h2>
    </mat-card-content>
    <mat-card-actions
      class="center"
      style="align-content: center !important; text-align: center !important"
    >
      <button
        style="width: 100%"
        mat-raised-button
        color="accent"
        mat-dialog-close
      >
        Entendido
      </button>
    </mat-card-actions>
  </mat-card>
</mat-dialog-content>